var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 1.65C17.75 0.8779 17.1221 0.25 16.35 0.25H1.65C0.8779 0.25 0.25 0.8779 0.25 1.65V16.35C0.25 17.1221 0.8779 17.75 1.65 17.75H16.35C17.1221 17.75 17.75 17.1221 17.75 16.35V1.65ZM8.65 5.15V8.65H5.15V5.15H8.65ZM12.85 5.15V8.65H9.35V5.15H12.85ZM17.05 5.15V8.65H13.55V5.15H17.05ZM4.45 8.65H0.95V5.15H4.45V8.65ZM0.95 9.35H4.45V12.85H0.95V9.35ZM5.15 9.35H8.65V12.85H5.15V9.35ZM8.65 13.55V17.05H5.15V13.55H8.65ZM9.35 13.55H12.85V17.05H9.35V13.55ZM9.35 12.85V9.35H12.85V12.85H9.35ZM13.55 9.35H17.05V12.85H13.55V9.35ZM1.65 0.95H16.35C16.736 0.95 17.05 1.26395 17.05 1.65V4.45H0.95V1.65C0.95 1.26395 1.26395 0.95 1.65 0.95ZM0.95 16.35V13.55H4.45V17.05H1.65C1.26395 17.05 0.95 16.736 0.95 16.35ZM16.35 17.05H13.55V13.55H17.05V16.35C17.05 16.736 16.736 17.05 16.35 17.05Z",
    fill: "#BACAD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/Table-icon.c0dfbd895b50563ddc030367b0e8833c.svg";
export { ForwardRef as ReactComponent };